<script>
  import Dollar from "./Dollar.svelte";

  export let name, amount;
</script>

<div
  class="list-group-item px-0 d-flex justify-content-between align-items-center text-nowrap"
>
  <span class="text-light-emphasis">{name}:</span>
  <div class="mx-auto px-1">&nbsp;</div>
  <span class="float-right" style="min-width:4em"
    ><Dollar writer={true} value={amount} /></span
  >
</div>
